module.exports = __webpack_public_path__ + "static/media/permutations-intro.09b4f570.jpg";